<template>
  <div>
    <!-- Detalhes Dos Pedidos Pendentes -->
    <div v-if="propDetalhesDoPedido">
      <div class="d-flex justify-content-between"
           style="font-size: 0.9rem;">
        <div class="d-flex text-left w-100"
             style="flex-direction: column;">
          <span><b>Número CNS Solicitante:</b> {{ propDetalhesDoPedido.pedido.numero_cnj_solicitante }}</span>
          <span><b>Tipo de registro:</b> {{ propDetalhesDoPedido.pedido.tipo_registro }}</span>
        </div>
        <div class="d-flex text-left w-100"
             style="flex-direction: column;">
          <span><b>Número CNS Recebedor:</b> {{ propDetalhesDoPedido.pedido.numero_cnj_recebedor }}</span>
        </div>
      </div>

      <div class="d-flex text-left w-100"
           style="flex-direction: column; font-size: 0.9rem;">
        <span v-if="!!propDetalhesDoPedido.cartorio"><b>Nome do requerente:</b> {{ propDetalhesDoPedido.pedido.nome_requerente }}</span>
        <span><b>Documento do requerente:</b> {{ propDetalhesDoPedido.pedido.documento_requerente || 'Não informado' }}</span>
      </div>

      <div class="d-flex justify-content-between"
           style="font-size: 0.9rem;">
        <div class="d-flex text-left w-100"
             style="flex-direction: column;">
          <span><b>Data ato fato:</b> {{ formatData(propDetalhesDoPedido.pedido.data_ato_fato) || 'Não informado' }}</span>
          <span><b>Número livro:</b> {{ propDetalhesDoPedido.pedido.num_livro || 'Não informado' }}</span>
          <span><b>Número registro:</b> {{ propDetalhesDoPedido.pedido.num_registro || 'Não informado' }}</span>
          <span><b>Depósito prévio:</b> R$ {{ propDetalhesDoPedido.pedido.deposito_previo.toFixed(2) }}</span>
        </div>
        <div class="d-flex text-left w-100"
             style="flex-direction: column;">
          <span><b>Data registro:</b> {{ formatData(propDetalhesDoPedido.pedido.data_registro) || 'Não informado' }}</span>
          <span><b>Número folha:</b> {{ propDetalhesDoPedido.pedido.num_folha || 'Não informado' }}</span>
          <span><b>Pedido cumprido:</b> {{ propDetalhesDoPedido.pedido.pedido_cumprido === 1 ? 'Sim' : 'Não' }}</span>
        </div>
      </div>

      <div class="d-flex text-left w-100"
           style="flex-direction: column; font-size: 0.9rem;">
        <span><b>Observações:</b> {{ propDetalhesDoPedido.pedido.obs_pedido || 'Não informado' }} </span>
      </div>
    </div>

    <!-- Detalhes Dos Pedidos Pendentes P13 -->
    <div v-else-if="propDetalhesDoPedidoP13">
      <div class="d-flex justify-content-between"
           style="font-size: 0.9rem;">
        <div class="text-left w-100">
          <span><b>Data de nascimento:</b> {{ formatData(propDetalhesDoPedidoP13.registrado.data_nascimento) || 'Não informado' }}</span>
        </div>
        <div class="text-left w-100 pl-3">
          <span><b>DNV:</b> {{ propDetalhesDoPedidoP13.registrado.dnv || 'Não informado' }}</span>
        </div>
      </div>

      <div class="text-left w-100"
           style="font-size: 0.9rem;">
        <span><b>Nome da mãe:</b> {{ propDetalhesDoPedidoP13.genitores[0].sexo === 'Feminino' ? propDetalhesDoPedidoP13.genitores[0].genitor_1 : propDetalhesDoPedidoP13.genitores[1].genitor_2 || 'Não informado' }}</span>
      </div>

      <div class="text-left w-100"
           style="font-size: 0.9rem;">
        <span><b>Cidade Unidade Interligada:</b> {{ propDetalhesDoPedidoP13.unidade_interligada.municipio || 'Não informado' }}</span>
      </div>

      <div class="text-left w-100"
           style="font-size: 0.9rem;">
        <span><b>Estado Unidade Interligada:</b> {{ propDetalhesDoPedidoP13.unidade_interligada.uf || 'Não informado' }}</span>
      </div>

      <div class="text-left w-100"
           style="font-size: 0.9rem;">
        <span><b>Nome do atendente:</b> {{ propDetalhesDoPedidoP13.nome_atendente || 'Não informado' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'PedidoDetalhado',
    props: {
      propDetalhesDoPedido: {
        type: Object,
        default: null
      },
      propDetalhesDoPedidoP13: {
        type: Object,
        default: null
      }
    },
    methods: {
      formatData (data) {
        return data ? moment(data).format('DD-MM-YYYY') : 'Não informado'
      }
    }
  }
</script>
